<template>
    <div class="table-responsive">
        <!-- Table Search -->
        <div class="input-group col-md-2 tab-sch tbl-sch rounded">
            <input v-on:keyup.enter="searchInventory" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
            <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
            <span @click="searchInventory()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>

        </div>
        <!-- Table Search -->
        <div class="row">
            <div class="col-md-10"></div>
            <div class="col-md-2">
                <toggle-button v-model="isHoldingFilled" @change="onChangeEventHandler"/> Filled Holdings
            </div>
        </div> 
        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
            <thead class="thead-light psticky">
            <tr>
                <th 
                    scope="col" 
                    class="sort"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerFirstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerFirstName'  ? 'sort-desc' : '']"  
                    @click="sort('customerFirstName')" >CUSTOMER</th>
                <th 
                    scope="col" 
                    class="sort"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountVal'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountVal'  ? 'sort-desc' : '']"  
                    @click="sort('accountVal')" >ACCOUNT</th>
                <th 
                    scope="col" 
                    class="sort"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipVal'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipVal'  ? 'sort-desc' : '']"  
                    @click="sort('cusipVal')" >CUSIP</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                    @click="sort('boughtDate')" >BOUGHT</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountType'  ? 'sort-desc' : '']"  
                    @click="sort('accountType')" >TYPE</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                    @click="sort('cost')" >COST</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                    @click="sort('quantity')" >QTY</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'filledQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'filledQuantity'  ? 'sort-desc' : '']"  
                    @click="sort('filledQuantity')" >FILLED QTY</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'assignedQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'assignedQuantity'  ? 'sort-desc' : '']"  
                    @click="sort('assignedQuantity')" >ASSIGNED QTY</th>
                 <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'isMargin'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'isMargin'  ? 'sort-desc' : '']"  
                    @click="sort('isMargin')" >IS MARGIN</th>
                <!-- <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'assignedTo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'assignedTo'  ? 'sort-desc' : '']"  
                    @click="sort('assignedTo')" >ASSIGNED TO</th> 
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'notes'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'notes'  ? 'sort-desc' : '']"  
                    @click="sort('notes')" >NOTES</th>                              -->
                <th 
                    scope="col" 
                    v-if="!isHoldingFilled"
                    class="text-center">Action</th>
            </tr>
            </thead>
            <tbody class="list no-cursor">
            <tr v-if="totalRows == 0 && !loading">
                <td><p class="nodata">No data available</p>
                </td>
            </tr>
            <tr v-for="inventory in inventoryList" :key="inventory.id" >
                <td>{{inventory.customerFirstName ? inventory.customerFirstName[0] : ""}}. {{inventory.customerLastName}}</td>
                <td>{{inventory.accountVal}}</td>
                <td>{{inventory.cusipVal}}</td>
                <td class="text-center">{{inventory.boughtDate ? moment(inventory.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</td>
                <td class="text-center">{{inventory.accountType}}</td>
                <td class="text-center">{{inventory.cost | currency}}</td>
                <td class="text-center">{{inventory.quantity}}</td>
                <td class="text-center">{{inventory.filledQuantity}}</td>
                <td class="text-center">{{inventory.assignedQuantity}}</td>
                <td class="text-center">{{inventory.isMargin}}</td>
                <!-- <td class="text-center">{{inventory.assToUserFirstLastName}}</td>
                <td class="text-center">{{inventory.notes}}</td> -->
                <td v-if="!isHoldingFilled" class="text-center">
                    <div class="d-inline-flex"> 
                        <a  @click="openAddInvModal(inventory)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                        <a  @click="checkOfferExist(inventory)" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt"></i></a>
                        <!-- <div class="dropdown">
                            <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                <button @click="openAddInvModal(inventory)"  class="dropdown-item" type="button">Edit</button>
                                
                            </div>
                        </div> -->
                    </div>    
                </td>
            </tr>
            </tbody>
        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

        </table>
        <!-- Pagination-->
        <b-pagination
            class="mt-4"
            :total-rows="totalRows"
            v-model="currentPage"
            :per-page="perPage"
            @input="getInventoryList(currentPage)"
        ></b-pagination>
        <div class="total-records">
            <span>Total Records : {{totalRows}}</span>
        </div>
        <addNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="selectedInventory"  v-bind:mode="'EDIT'" @close="closeAddInvModal()" />

        </div>   
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import addNewInventory from "./ImsAddInventoryModal";

export default {
  name: "imsinventoryListCompleted",
  components :{
      addNewInventory
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "traderName",
        sortOrder: "ASC",
        inventoryList : [],
        addInvModalOpen : false,
        selectedInventory : {},
        isHoldingFilled : false

    };
  },
  methods: { 
    onChangeEventHandler(){
        this.getInventoryList(); 
    },
    openAddInvModal(data){
      this.selectedInventory = data;  
      this.addInvModalOpen = true;
    }, 
    closeAddInvModal(){
      this.addInvModalOpen = false;
      this.getInventoryList();
    },
    searchInventory(){
        this.getInventoryList(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getInventoryList(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getInventoryList();
    },
    getInventoryList(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&listFilled="+
            this.isHoldingFilled,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.isMargin === null || element.isMargin === ""){
               element.isMargin = "N/A";
            }else{
              element.isMargin ? element.isMargin = "YES" : element.isMargin = "NO"
            }
           });
          this.inventoryList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    deleteInv(inv){
        if(this.isUploadInProgress()){
            this.$alert("Holding upload is currently in progress. Please try again once it’s complete.","","info")

        }else{
        var message = "Are you sure you want to delete this holding?";
        this.$confirm(message,"Delete holding","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .put(config.baseUrlBidSide + "/inventory/delete?inventoryId="+inv.id,"",auth)
            .then(() => {
                this.loading = false;              
                this.getInventoryList();              
            })
            .catch(() => {
                this.loading = false;              
            });
        });
    }

    },
    checkOfferExist(inv){
         this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlBidSide + "/inventory/is-offer-exist?inventoryId="+inv.id,auth)
            .then((result) => {
                this.loading = false;
                if(result.data.isOfferExist){
                    this.$alert("Can't delete or update. There is an existing offer for this holding","","warning")
                }else if(result.data.isBidWantedExist){
                    this.$alert("Can't delete or update. There is an existing bid wanted for this holding","","warning")
                }
                else{
                   this.deleteInv(inv)
                }              
                // console.log(result.data)         
            })
            .catch(() => {
                this.loading = false;              
            });
    }
   
  },
  mounted() {
    this.getInventoryList();
    this.$root.$on("invadded", () => {
        this.getInventoryList(); 
    });
    this.$root.$on("holdingimported", () => {
        this.getInventoryList(); 
    });
  }
};
</script>